import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map, of } from 'rxjs';
import { AuthenticationService } from '../services/authentification.service';
import { APP_ROUTES } from '../constants/app-routes';

/** Protège les routes : stub OK, sinon JWT ou refresh, sinon redirection Launcher. */
export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthenticationService);

  if (auth.isStubAuth()) {
    return of(true);
  }

  if (state.url.includes('connexion')) {
    const returnPath = route.queryParamMap.get('returnUrl') || APP_ROUTES.accueil;
    auth.redirectToLauncherLogin(returnPath);
    return of(false);
  }

  if (auth.isUserLoggedIn()) {
    return of(true);
  }

  return auth.refreshAccessToken().pipe(
    map((refreshed) => {
      if (refreshed) {
        return true;
      }

      auth.abandonSession();
      auth.redirectToLauncherLogin(state.url);
      return false;
    })
  );
};
